
import { Input } from "@/components/ui/input";
import { Loader2, Search, X } from "lucide-react";

interface BlogSearchProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  isSearching?: boolean;
}

export const BlogSearch = ({ searchTerm, onSearchChange, isSearching = false }: BlogSearchProps) => {
  return (
    <div className="relative flex-1">
      {isSearching ? (
        <Loader2 className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4 animate-spin" />
      ) : (
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
      )}
      
      <Input
        placeholder="Cerca articoli... (minimo 2 caratteri)"
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="pl-10"
        aria-label="Cerca articoli"
      />
      
      {searchTerm && (
        <button
          onClick={() => onSearchChange("")}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-foreground"
          aria-label="Cancella ricerca"
          type="button"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
